import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { contactData } from '../data/mock';
import { Card } from './ui/card';

const LocationSection = () => {
  const { language } = useLanguage();

  const translations = {
    en: {
      title: 'Find Us',
      subtitle: 'Located in the heart of Bordeaux'
    },
    fr: {
      title: 'Où Nous Trouver',
      subtitle: 'Situé au cœur de Bordeaux'
    }
  };

  const t = translations[language];

  // Google Maps embed URL
  const mapUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2829.087!2d-0.5792!3d44.8378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd5527e8f751ca81%3A0x796386037b397a1!2s9%20Rue%20Parlement%20Saint-Pierre%2C%2033000%20Bordeaux%2C%20France!5e0!3m2!1sen!2sus!4v1234567890`;

  return (
    <section id="location" className="py-24 bg-[#0a1929]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#c9a961] mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-white/70">
            {t.subtitle}
          </p>
        </div>

        {/* Map Container */}
        <Card className="bg-white/5 border-[#c9a961]/20 overflow-hidden">
          <div className="aspect-video w-full">
            <iframe
              src={mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Sid's Deli Location"
              className="w-full h-full"
            ></iframe>
          </div>
        </Card>

        {/* Location Details with Background Image */}
        <div className="mt-12 relative rounded-lg overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/siapch6m_WhatsApp%20Image%202025-12-28%20at%205.23.23%20PM%20%281%29.jpeg" 
              alt="Preparing on the Plancha" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0a1929]/85"></div>
          </div>
          <div className="relative z-10 p-8 md:p-12 text-center">
            <h3 className="text-3xl font-bold text-[#c9a961] mb-4">
              {contactData.address.street}
            </h3>
            <p className="text-xl text-white/90 mb-6">
              {contactData.address.city}, {contactData.address.country} {contactData.address.postalCode}
            </p>
            <div className="text-white/80 max-w-md mx-auto">
              <p className="text-lg font-semibold mb-3">{language === 'en' ? 'Hours of Operation' : 'Horaires d\'ouverture'}</p>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
                <span className="text-left text-red-400">{language === 'en' ? 'Monday' : 'Lundi'}:</span>
                <span className="text-right text-red-400">{language === 'en' ? contactData.hours.en.monday : contactData.hours.fr.monday}</span>
                
                <span className="text-left">{language === 'en' ? 'Tuesday' : 'Mardi'}:</span>
                <span className="text-right">{language === 'en' ? contactData.hours.en.tuesday : contactData.hours.fr.tuesday}</span>
                
                <span className="text-left">{language === 'en' ? 'Wednesday' : 'Mercredi'}:</span>
                <span className="text-right">{language === 'en' ? contactData.hours.en.wednesday : contactData.hours.fr.wednesday}</span>
                
                <span className="text-left">{language === 'en' ? 'Thursday' : 'Jeudi'}:</span>
                <span className="text-right">{language === 'en' ? contactData.hours.en.thursday : contactData.hours.fr.thursday}</span>
                
                <span className="text-left">{language === 'en' ? 'Friday' : 'Vendredi'}:</span>
                <span className="text-right">{language === 'en' ? contactData.hours.en.friday : contactData.hours.fr.friday}</span>
                
                <span className="text-left">{language === 'en' ? 'Saturday' : 'Samedi'}:</span>
                <span className="text-right">{language === 'en' ? contactData.hours.en.saturday : contactData.hours.fr.saturday}</span>
                
                <span className="text-left">{language === 'en' ? 'Sunday' : 'Dimanche'}:</span>
                <span className="text-right">{language === 'en' ? contactData.hours.en.sunday : contactData.hours.fr.sunday}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;